/*
 * @Description: sku组合算法
 * @Author: guqiang
 * @Date: 2021-10-19 10:10:06
 * @LastEditors: guqiang
 * @LastEditTime: 2021-10-19 10:15:19
 */

export default function calcSkuAssembly() {
    return Array.prototype.reduce.call(
        arguments,
        function(a, b) {
            var ret = [];
            a.forEach(function(a) {
                b.forEach(function(b) {
                    ret.push(a.concat([b]));
                });
            });
            return ret;
        },
        [[]]
    );
}


